import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/shared/Layout';
import ProtectedRoute from './components/shared/ProtectedRoute';

// Pages
import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Checklist from './pages/broker/Checklist';
import Submitted from './pages/broker/Submitted';
import InspectorDashboard from './pages/inspector/Dashboard';
import SubmissionDetail from './pages/inspector/SubmissionDetail';
import AdminDashboard from './pages/admin/Dashboard';
import Firms from './pages/admin/Firms';
import Users from './pages/admin/Users';
import Submissions from './pages/admin/Submissions';
import EmailLogs from './pages/admin/EmailLogs';
import AuditLogs from './pages/admin/AuditLogs';
import Cycles from './pages/admin/Cycles';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Protected Routes */}
          <Route
            path="/change-password"
            element={
              <ProtectedRoute>
                <Layout>
                  <ChangePassword />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Broker Routes */}
          <Route
            path="/checklist"
            element={
              <ProtectedRoute allowedRoles={['broker']}>
                <Layout>
                  <Checklist />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/checklist/submitted"
            element={
              <ProtectedRoute allowedRoles={['broker']}>
                <Layout>
                  <Submitted />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Inspector Routes */}
          <Route
            path="/inspector"
            element={
              <ProtectedRoute allowedRoles={['inspector']}>
                <Layout>
                  <InspectorDashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/inspector/submissions/:id"
            element={
              <ProtectedRoute allowedRoles={['inspector', 'admin']}>
                <Layout>
                  <SubmissionDetail />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <AdminDashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/cycles"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <Cycles />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/firms"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <Firms />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <Users />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/submissions"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <Submissions />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/email-logs"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <EmailLogs />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/audit-logs"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <AuditLogs />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* 404 */}
          <Route
            path="*"
            element={
              <div className="min-h-screen bg-offWhite flex items-center justify-center">
                <div className="text-center">
                  <h1 className="text-4xl font-bold text-dark mb-4">404</h1>
                  <p className="text-grey">Page not found</p>
                </div>
              </div>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
